import { TextField } from '@mui/material'
import { CSSProperties } from 'react'
import { FieldErrors, UseFormRegisterReturn } from 'react-hook-form'
import { styled } from 'styled-components'

interface Props {
  id: string
  name?: string
  register?: UseFormRegisterReturn
  label?: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
  type?: 'text' | 'number' | 'decimal' | 'datetime-local' | 'password' | 'email'
  fullWidth?: boolean
  valiant?: 'standard' | 'outlined' | 'filled'
  errors?: FieldErrors
  size?: 'small' | 'medium'
  style?: CSSProperties
  onInput?: (v: string) => void
  multiline?: boolean
}

const StyledTextField = styled(TextField)(() => ({
  '& .Mui-disabled': {
    WebkitTextFillColor: 'black',
  },
  '& .MuiInputBase-input': {
    WebkitTextFillColor: 'black',
  },
}))

const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
  event.stopPropagation()
}
export default function KanseiTextField(props: Props) {
  const {
    id,
    label = '',
    placeholder = '',
    required = false,
    fullWidth = true,
    valiant = 'outlined',
    disabled = false,
    type = 'text',
    register,
    errors = {},
    size = 'small',
    style: style = {},
    onInput,
    multiline = false,
  } = props

  const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onInput) {
      onInput(event.target.value)
    }
  }

  const name = register?.name || ''

  const getErrorMessage = (
    errors: FieldErrors | undefined,
  ): string | undefined => {
    if (!errors) return undefined

    const keys = name.split('.').map((key) => {
      return isNaN(Number(key)) ? key : Number(key)
    })

    let error: any = errors
    for (const key of keys) {
      if (error[key] !== undefined) {
        error = error[key]
      } else {
        return undefined
      }
    }

    return error?.message as string | undefined
  }
  const errorMessage = getErrorMessage(errors)

  return (
    <StyledTextField
      name={register?.name}
      id={id}
      label={label}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      type={type}
      fullWidth={fullWidth}
      variant={valiant}
      {...register}
      error={!!errorMessage}
      helperText={errorMessage?.toString()}
      size={size}
      sx={style}
      onInput={handleInput}
      autoComplete="off"
      multiline={multiline}
      inputProps={
        type === 'decimal'
          ? { step: 'any' }
          : type === 'number'
            ? { step: '1' }
            : undefined
      }
      onKeyDown={handleKeyDown}
    />
  )
}
